export const prefix = 'fields';
export const FEW_ADDITIONAL_FILEDS_TYPE_ID = 14895; // 2009664
export const MANY_ADDITIONAL_FILEDS_TYPE_ID = 14894; // 2009672
export const IGNORE_FIELDS_PARAM = 'type';

export const FEW_FIELDS_IDS = {
  cleaning: '78c13720-f399-44f5-9eb3-60ba25c815a9',
};

export const MANY_FIELDS_IDS = {
  dateOne: '333b67bc-1ffc-407b-9d62-d230a678a850',
  dateTwo: 'd1a7ae88-9aa2-4f13-a6c0-44cfbbbfa3f4',
  responsibles: 'e5b0dfad-a6bc-48cb-aeee-8dd4d1b91fff',

  responsibleTwo: 'c25390a4-adde-4651-935e-79e79725a775',
  responsibleTwoFiles: '28d69b72-ba56-4228-a644-ae9211f3c9c4',

  podryad: '48bbd2a2-05b2-41b6-bded-2f969b0fd50d',
  podryadEmployeeFiles: '5deceb83-24cf-4029-9e5e-a8f682b3d229',

  markaAuto: 'ab16508d-19f5-43ca-a7f3-39b8a254a0e8',
  nomerAuto: '3ebb6bdc-e269-4511-9a36-8c823b88fe23',
  parkingSlots: 'a27b1b16-785a-4f18-a535-1aa1373d323d',
};

export const FIELDS_BY_ID = {
  [FEW_ADDITIONAL_FILEDS_TYPE_ID]: FEW_FIELDS_IDS,
  [MANY_ADDITIONAL_FILEDS_TYPE_ID]: MANY_FIELDS_IDS,
} as { [key: string]: any };

export const DATE_TIME_FIELDS = [MANY_FIELDS_IDS.dateOne, MANY_FIELDS_IDS.dateTwo];
export const FILE_FIELDS = [
  MANY_FIELDS_IDS.responsibleTwoFiles,
  MANY_FIELDS_IDS.podryadEmployeeFiles,
];
